(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/collections/wagers.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/collections/wagers.js');

(function(Backbone, svs) {
  'use strict';

  svs.syndicate.core.collections.Wagers = Backbone.Collection.extend({
    url: function() {
      var url = svs.core.jupiter.url() + '/social/1/syndicates/' + this.syndicateId + '/wagers?count=' + svs.syndicate.core.data.constants.WAGERS_PER_LOAD,
        pageSortingKey = this.getPageSortingKey();

      if (pageSortingKey) {
        url += '&pagingSortKey=' + pageSortingKey;
      }

      return url;
    },

    initialize: function(wagers, options) {
      this.reset(wagers);
      if (options && options.syndicateId) {
        this.syndicateId = options.syndicateId;
      }

      if (options && options.moreItems) {
        this.moreItems = options.moreItems;
      }
    },

    getPageSortingKey: function() {
      if (this.length > 0) {
        return this.models[this.length - 1].get('pagingSortKey');
      }
      return 0;
    },

    parse: function(data) {
      this.moreItems = data.moreItems;
      return data.wagers;
    },

    fetch: function(options) {
      if (!this.moreItems) {
        if (typeof options.success === 'function') {
          return options.success();
        }
        return;

      }

      return Backbone.Collection.prototype.fetch.call(this, options);
    }
  });
})(Backbone, svs);


 })(window);